<div class="container">
    <div class="premium-access-content">
        <span class="sub-title">Vernieuwd examen</span>
        <h2>Sinds 1 maart 2009 bestaat het theorie-examen uit 3 onderdelen</h2>
        <p>Wij behandelen al deze 3 categorieën 1 voor 1. Je slaagt voor het theorie-examen als je minimaal 13 vragen over gevarenherkenning goed hebt daarnaast moet je nog minimaal 35 vragen over wetten en verkeersregels/inzicht en risico’s goed hebben. Het lijkt heel wat, maar met de videocursus van Theorie Coach haal je het met je ogen dicht!</p>
        <a routerLink="/theoriepakketten" class="default-btn"><i class="flaticon-user"></i>Koop nu je theoriepakket<span></span></a>
    </div>
</div>
